import { useNavigate } from '@tanstack/react-location'
import { upsertLevel } from 'MediaManager/services/levels'
import React, { useEffect, useState } from 'react'
import Toggle from 'shared/components/Toggle'

function LevelsEditor({ line }) {
  const navigate = useNavigate()

  async function onChange(levelId, payload) {
    upsertLevel({
      id: levelId,
      unit_type_id: line.id,
      ...payload,
    })
  }

  const [state, setState] = useState({})

  useEffect(() => {
    if (line) {
      const state = line.unit_type_levels.reduce((acc, l) => {
        acc[l.id] = {
          ...(acc[l.id] || {}),
          is_entrance: l.is_entrance,
        }
        return acc
      }, {})

      setState(state)
    }
  }, [line])

  return (
    <>
      {line && (
        <div className="data-table">
          <table className="table">
            <thead>
              <tr>
                <th>Id</th>
                <th>Floor number</th>
                <th>Display name</th>
                <th>Is entrance</th>
                <th>Exterior space size</th>
                <th>Height</th>
                <th>Size of balcony</th>
              </tr>
            </thead>

            <tbody>
              {line.unit_type_levels.map((l, index) => (
                <tr
                  onClick={() => {
                    navigate({ to: `/level/edit?id=${l.id}&unit_type_id=${line.id}` })
                  }}
                  key={index}
                >
                  <td>{l.id}</td>
                  <td>{l.floor_number}</td>
                  <td>{l.display_name || '-'}</td>
                  <td onClick={(e) => e.stopPropagation()}>
                    <Toggle
                      checked={state[l.id]?.is_entrance}
                      onChange={() => {
                        onChange(l.id, { is_entrance: !state[l.id]?.is_entrance })
                        setState((state) => ({ ...state, [l.id]: { is_entrance: !state[l.id]?.is_entrance } }))
                      }}
                    />
                  </td>
                  <td>{l.exterior_space_size || '-'}</td>
                  <td>{l.height || '-'}</td>
                  <td>{l.size_of_balcony || '-'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </>
  )
}

export default LevelsEditor
